// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c6b5597","453":"8aa89601","667":"b27490ed","867":"5cee63fc"}[chunkId] + ".chunk.js";
};